import React, { useEffect, useState } from "react";
import { Box, Button, getColor, Modal, Typography, useToast } from "fds";
import { v4 as uuidv4 } from "uuid";
import "./index.scss";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import { QRCodeCanvas } from "qrcode.react";
import { t } from "i18next";

interface GoogleOTPRegisterModalProps {
  open: boolean;
  requestId: string;
  isMobile?: boolean;
  onClose: () => void;
}
const GoogleOTPRegisterModal: React.FC<GoogleOTPRegisterModalProps> = ({
  open,
  requestId,
  isMobile,
  onClose,
}) => {
  const toast = useToast();
  const { getGoogleOTPInfo, registerGoogleOTPInfo } = useLoginStore();
  const [qr, changeQr] = useState({ account: "", key: "" });
  useEffect(() => {
    getGoogleOTPInfo(requestId).then((resp: any) => changeQr(resp.payload));
  }, []);

  /** Google OTP 에 사용자 아이디 등록 */
  const handleRegisterIDToGoogle = () => {
    registerGoogleOTPInfo(requestId);
    toast.toastMsg(uuidv4(), t("login.googleOTP.initSuccess"), "success");
    onClose();
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      isMobile={isMobile}
      isExit={!isMobile}
      title={t("login.googleOTP.register")}
      width={600}
      body={
        <Box
          direction="column"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
        >
          <Typography
            type="body1_rg"
            textAlign="center"
            whiteSpace="break-spaces"
          >
            {t("login.googleOTP.registerDesc")}
          </Typography>
          <Box classes="mg mt-20">
            <QRCodeCanvas value={qr?.account} size={100} />
            <Box
              direction="column"
              alignItems="center"
              justifyContent="center"
              classes="mg ml-40"
            >
              <a href="https://play.google.com/store/search?q=google%20otp&c=apps&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img
                  style={{ width: "120px", height: "40px" }}
                  alt="Get it on Google Play"
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                />
              </a>
              <a href="https://apps.apple.com/kr/app/google-authenticator/id388497605?itsct=apps_box_badge&amp;itscg=30200">
                <img
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=120x40&amp;releaseDate=1284940800"
                  alt="Download on the App Store"
                />
              </a>
            </Box>
          </Box>
          <Box classes="googleOtpModal-key">
            <Typography type="h2" exactColor={getColor("COLOR_TEXT_BRAND")}>
              {qr?.key}
            </Typography>
          </Box>
          <Typography
            type="body2_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("login.googleOTP.confirmDesc")}
          </Typography>
        </Box>
      }
      footer={
        isMobile ? (
          <Box width="100%" alignItems="center" justifyContent="center">
            <Typography
              textAlign="center"
              type="body1_md"
              exactColor={"COLOR_TEXT_BRAND"}
              onClick={handleRegisterIDToGoogle}
            >
              {t("login.googleOTP.registerBtn")}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Button
              btnStyle="fill"
              label={t("login.googleOTP.registerBtn")}
              onClick={handleRegisterIDToGoogle}
            />
          </Box>
        )
      }
    />
  );
};
export default GoogleOTPRegisterModal;
